import { OccupancyEnum } from "@gtpl/shared-models/masters";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('place_list_items')
export class PlaceListItems {
    @PrimaryGeneratedColumn('increment', {
        name: 'place_list_items_id',
    })
    placeListItemsId: number;

    @Column('int', {
        nullable: false,
        name: 'store_consumption_id',
    })
    storeConsumptionId: number;

    @Column('int', {
        nullable: false,
        name: 'item_id',
    })
    itemId: number;

    @Column('decimal', {
        nullable: false,
        name: 'issued_qty',
        default:0
    })
    issuedQty: number;
    @Column('decimal', {
        nullable: false,
        name: 'reporting_qty',
        default:0
    })
    reportingQty: number;

    @Column('varchar', {
        nullable: false,
        name: 'rack_position',
    })
    rackPosition: string;

    @Column('int', {
        nullable: false,
        name: 'rack_position_id',
    })
    rackPositionId: number;

    @Column('int', {
        nullable: true,
        name: 'pallet_code',
    })
    palletCode: number;

    @Column('int', {
        nullable: true,
        name: 'rack_reserve_code'
      })
      rackReserveCode: number;
    
      @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;
      @Column({
        type: 'enum',
        enum: OccupancyEnum,
        nullable: false,
        default: OccupancyEnum.NOT_OCCUPIED,
        name: 'occupancy'
      })
      occupancy: OccupancyEnum;
    // @Column('int', { rack pos id 
    //     nullable: false,
    //     name: 'reporting_cases',
    //     default: 0
    // })
    // reportingCases: number;

    @Column("int", {
        nullable: false,
        name: "pallet_capacity",
        default: 0
    })
    palletCapacity: number;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50,
        default: "Admin",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}